// 根据环境不同来创建preview地址

export default () => {
    // 如果是通过容器的host访问的，则只需要替换visualediting即可。
    /* eslint-disable no-undef */
    if (window.location.href.includes('shank.ifeng')) {
        return `${window.location.href.split('visualediting')[0]}preview`;
    } else if (FullPagePreviewUrl.includes('shanklist')) {
        // 如果其他情况，比如说在测试服务器或者正式服务器上访问时，需要对整个访问地址的host替换为一个新的host地址，并对visualediting进行替换
        // 此处由于在web-list中配置的FullPagePreviewUrl时，增加了一个 shanklist，主要原因是web-list项目中，有的地址被映射为非shanklist的地址，
        // 邓时那边拿不到标识来进行服务器派发了，但是有些地址又是遵循weblist上的命名规则的，所以需要对重复的shanklist进行去除。
        return `${FullPagePreviewUrl}${
            window.location.pathname
                .split('shanklist/')
                .join('')
                .split('visualediting')[0]
        }preview`;
    } else if (FullPagePreviewUrl === '') {
        return `${window.location.href.split('visualediting')[0]}preview`;
    } else {
        return `${FullPagePreviewUrl}${window.location.pathname.split('visualediting')[0]}preview`;
    }
    /* eslint-enable no-undef */
};
